<!-- Imagen header -->
    <div class="imagen-header">
        <!-- Imagen placeholder gris como en contacto.html -->
    </div>

    <!-- Contenido de la política -->
    <main class="contenido-politica">
        <div class="contenedor">
            <h1>Política de la calidad</h1>
            
            <section class="seccion-politica">
                <p><strong>Corporación Rehobot Contratistas Generales S.A.C.</strong> Empresa especializada en brindar soluciones integrales, en los servicios de Estudios hidrogeológicos, diseño constructivo en función a la litología del suelo, perforación del pozo considerando ingeniería conveniente aplicar por características litológicas del acuífero subterráneo, asegurando caudal y calidad del agua subterránea, equipamiento de bombeo considerando un diseño hidráulico, así como diseño y construcción de obras sanitarias, redes de agua y desagüe, Instalaciones eléctricas en baja y mediana tensión, electromecánica, abastecimiento de materiales acondicionados en nuestro taller de maestranza.</p>
                
                <p>Convencidos que una buena gestión de la calidad, nos permite mejorar continuamente y expande nuestras oportunidades, la gerencia asume los siguientes compromisos:</p>
            </section>

            <section class="seccion-politica">
                <ul>
                    <li>Integrar los objetivos de la gestión de la Calidad hacia todas operaciones de la empresa cumpliendo con legales, aplicables de conformidad con los requerimientos contractuales y los estándares de nuestra organización.</li>
                    <li>Desarrollar nuestros servicios bajo las especificaciones técnicas que aseguren un buen desempeño en su uso y sostenibilidad en su funcionamiento, buscando la superación de las expectativas de nuestros clientes.</li>
                    <li>Mantener la actualización técnica de nuestros colaboradores para asegurar su buen desempeño en las tareas encomendadas.</li>
                    <li>Desarrollar acciones para la mejora continua del Sistema de Gestión de la Calidad determinado en cada proceso que desarrolle Corporación REHOBOT.</li>
                    <li>Aplicar medidas preventivas y correctivas para alinear nuestras acciones hacia nuestra Política de la Calidad</li>
                </ul>
            </section>

            <section class="seccion-politica">
                <p>La gerencia de <strong>CORPORACIÓN REHOBOT CONTRATISTAS GENERALES. S.A.C</strong>, suscribe la presente política para garantizar la mejora de sus procesos, por ello dispondrá de los recursos necesarios para su difusión y cumplimiento.</p>
            </section>

            <section class="seccion-politica firma-empresa">
                <div class="info-empresa">
                    <p><strong>Corporación REHOBOT</strong></p>
                    <p><strong>Lima 05 de marzo del 2021</strong></p>
                </div>
            </section>
        </div>
    </main>